import { Component, OnInit, Input } from '@angular/core';
import 'ol/ol.css';
import { SharingDataService } from '../Services/sharing-data.service';
import { GridTableParametersService } from './../template/gridTemplate/gridTableParameters.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
})
export class MapComponent implements OnInit {
  resourceDefinition;

  constructor(
    private shareData: SharingDataService,
    public grid: GridTableParametersService,
  ) { }



  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
  }
}